"use client";

import { useEffect, useState } from "react";
import { getCurrentUser } from "@/lib/auth";

/**
 * Returns true if the current user can edit job-description / group fields for
 * this entity (admin, superadmin, or holds a chair/vice-chair/leader role).
 */
export function useGroupEditor(entityType: string, entityId: string | number): boolean {
    const [canEdit, setCanEdit] = useState(false);

    useEffect(() => {
        let cancelled = false;
        async function load() {
            const profile = await getCurrentUser();
            if (cancelled || !profile) return;

            const role = (profile.role || "").toLowerCase();
            if (role === "admin" || role === "superadmin") {
                setCanEdit(true);
                return;
            }

            const assignments = profile.assignments || [];
            const match = assignments.some((a: { entity_id?: string | number; entity_type?: string; role?: string }) => {
                if (String(a.entity_id) !== String(entityId)) return false;
                if ((a.entity_type || "").toLowerCase() !== String(entityType).toLowerCase()) return false;
                const r = (a.role || "").toLowerCase();
                return r.includes("chair") || r.includes("leader") || r.includes("president");
            });

            setCanEdit(match);
        }
        load();
        return () => { cancelled = true; };
    }, [entityType, entityId]);

    return canEdit;
}
